import styled from 'styled-components';
export const CreateSection = styled.div`
  padding: calc(100vw*(35/375)) calc(100vw*(17/375)) 0;
`;
export const TitleWrapper = styled.div`
  background: #F7F7F7;
  border-radius: 10px;
  padding: calc(100vw*(16/375)) 0;
  margin-bottom: calc(100vw*(16/375));
  display: flex;
  align-items: center;
  justify-content: center;
`;


export const TitleInput = styled.input`
  &::placeholder{
    font-style: normal;
    font-weight: 500;
    font-size: calc(100vw*(14/375));
    line-height: calc(100vw*(20/375));
    color: #D7D7D7;
    text-align: center;
  }
  width : calc(100vw*(102/375));
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid #FFFFFF;
  box-sizing: border-box;
  border-radius: 3px;
  padding : calc(100vw*(3/375)) calc(100vw*(12/375));

  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw*(14/375));
  line-height: calc(100vw*(20/375));
  color: #121212;
`
export const PreTitleTxt = styled.span`
  margin-right:calc(100vw*(24/375));
`;
export const PostTitleTxt = styled.span`
  margin-left:calc(100vw*(24/375));
`;
export const DescriptionWrapper = styled.div`
  background: #F7F7F7;
  border-radius: 10px;
  padding: calc(100vw*(21/375)) calc(100vw*(22/375));
  text-align: center;
  margin-bottom: calc(100vw*(35/375));
  position: relative;
`;

export const Description = styled.textarea`
  background: #F7F7F7;
  width : 100%;
  &::placeholder{
    font-style: normal;
    font-weight: 500;
    font-size: calc(100vw*(14/375));
    line-height: calc(100vw*(20/375));
    color: #D7D7D7; 
  }
  font-style: normal;
  font-weight: normal;
  font-size: calc(100vw*(14/375));
  line-height: calc(100vw*(20/375));
  color: #121212;
`;
export const DescriptionCount = styled.div`
position: absolute;
right : calc(100vw*(10/375));
bottom : calc(100vw*(10/375));
font-weight: normal;
font-size: calc(100vw*(12/375));
line-height: calc(100vw*(17/375));
color: #989898;
`

export const CapacityWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`
export const CapacityLeft = styled.div`
  font-weight: bold;
  font-size: calc(100vw*(16/375));
  line-height: calc(100vw*(23/375));
  color: #121212;
`;
export const CapacityRight = styled.div`
  display: flex;
  align-items: center;
`;
export const CapacityBtn = styled.span`
display: inline-block
`;
export const CapacityBtnImg = styled.img``;
export const CapacityCnt = styled.span`
  font-weight: normal;
  font-size: calc(100vw*(16/375));
  line-height: calc(100vw*(23/375));
  color: #121212;
  margin : 0 calc(100vw*(16/375));
`;